// extracted by mini-css-extract-plugin
export default {"flavors_title":"H5","no_selected_flavors":"I5","success":"J5","select_flavors_wrapper":"K5","flavors_select":"L5","custom_select_control":"M5","opened":"N5","subtitle":"O5","selected_flavors":"P5","selected_flavor_item":"Q5","selected_flavor_item_image":"R5","selected_flavor_item_title":"S5","selected_flavor_item_qty":"T5","drawer_header":"U5"};
    if(module.hot) {
      // 1715276860181
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  